/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * What one person of a household got.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto
 */
export interface WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto {
    /**
     * Name from the member register.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto
     */
    name?: string | null;
    /**
     * The times where the person has a place.
     * @type {Array<number>}
     * @memberof WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto
     */
    acceptedTimeIds?: Array<number> | null;
    /**
     * The times where the person is on the waitlist.
     * @type {Array<number>}
     * @memberof WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto
     */
    waitlistedTimeIds?: Array<number> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto {
    return WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'acceptedTimeIds': !exists(json, 'acceptedTimeIds') ? undefined : json['acceptedTimeIds'],
        'waitlistedTimeIds': !exists(json, 'waitlistedTimeIds') ? undefined : json['waitlistedTimeIds'],
    };
}

export function WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServicePersonReplyResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'acceptedTimeIds': value.acceptedTimeIds,
        'waitlistedTimeIds': value.waitlistedTimeIds,
    };
}

